function findClosingBrace(css: string, openIndex: number): number {
  let depth = 0
  for (let i = openIndex; i < css.length; i++) {
    const ch = css[i]
    if (ch === '{') depth += 1
    else if (ch === '}') {
      depth -= 1
      if (depth === 0) return i
    }
  }
  return -1
}

function prefixSelector(selector: string, scope: string): string {
  if (!selector) return ''
  if (selector.startsWith(scope)) return selector
  if (selector === 'html' || selector === 'body' || selector === ':root') return scope
  return `${scope} ${selector}`
}

function scopeCssBlock(source: string, scope: string): string {
  let out = ''
  let i = 0
  while (i < source.length) {
    while (i < source.length && /\s/.test(source[i])) i += 1
    if (i >= source.length) break
    const open = source.indexOf('{', i)
    if (open < 0) break
    const prelude = source.slice(i, open).trim()
    const close = findClosingBrace(source, open)
    if (close < 0) break
    const body = source.slice(open + 1, close)
    if (prelude) {
      if (/^@(media|supports)\b/i.test(prelude)) {
        out += `${prelude}{${scopeCssBlock(body, scope)}}`
      } else if (prelude.startsWith('@')) {
        out += `${prelude}{${body}}`
      } else {
        const selectors = prelude
          .split(',')
          .map((part) => prefixSelector(part.trim(), scope))
          .filter(Boolean)
          .join(',')
        if (selectors) out += `${selectors}{${body}}`
      }
    }
    i = close + 1
  }
  return out
}

/** Prefix field CSS so a real `<style>` element cannot restyle the rest of the form. */
export function scopeCssToAncestor(css: string, ancestor: string): string {
  const scope = String(ancestor ?? '').trim()
  const source = String(css ?? '')
    .replace(/\/\*[\s\S]*?\*\//g, '')
    .replace(/<\/?\s*style\b[^>]*>/gi, '')
    .replace(/@import\b[^;]*;?/gi, '')
    .replace(/javascript\s*:/gi, '')
  if (!source.trim() || !scope) return ''
  return scopeCssBlock(source, scope).trim()
}
